import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const contragentsService = {
  get,
  find,
  add,
  edit,
  del,
  changeGroup,
  getGroups,
  addGroup,
  editGroup,
  delGroups,
  getShablon,
  getShablonUser,
  addShablon,
  editShablon,
  delShablon,
  readImportFile,
  importContragents
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'contragents'
};

function extract(r) {
  return r.data;
}

async function get(type: number = 0) {
  return axios.get(`${model.baseUrl}${model.controller}?type=${type}`).then(extract);
}

async function find(email) {
  return axios.get(`${model.baseUrl}${model.controller}/find?email=${encodeURIComponent(email)}`).then(extract);
}

async function add(contragentsGroupId, users) {
  return axios.put(`${model.baseUrl}${model.controller}`, { contragentsGroupId, users }).then(extract);
}

async function edit(contragent) {
  return axios.patch(`${model.baseUrl}${model.controller}`, contragent).then(extract);
}

async function del(ids: number[]) {
  return axios.delete(`${model.baseUrl}${model.controller}`, { data: ids }).then(extract);
}

async function changeGroup(groupId: number, ids: number[]) {
  return axios.patch(`${model.baseUrl}${model.controller}/changegroup`, { groupId, ids }).then(extract);
}

async function getGroups() {
  return axios.get(`${model.baseUrl}${model.controller}/groups`).then(extract);
}

async function addGroup(name: string) {
  return axios.put(`${model.baseUrl}${model.controller}/groups`, { name }).then(extract);
}

async function editGroup(id: number, name: string) {
  return axios.patch(`${model.baseUrl}${model.controller}/groups`, { id, name }).then(extract);
}

async function delGroups(ids: number[]) {
  return axios.delete(`${model.baseUrl}${model.controller}/groups`, { data: ids }).then(extract);
}

async function getShablon() {
  return axios.get(`${model.baseUrl}${model.controller}/shablon`).then(extract).then(extract);
}

async function getShablonUser(contagentShablonId: number) {
  return axios.get(`${model.baseUrl}${model.controller}/shablonUser?contagentShablonId=${contagentShablonId}`).then(extract).then(extract);
}

async function addShablon(pShablonName :string, pContragentUsers:string) {
  return axios.put(`${model.baseUrl}${model.controller}/shablon`, { pContagentShablonId: 0, pShablonName, pContragentUsers }).then(extract);
}

async function editShablon(pContagentShablonId: number, pShablonName :string, pContragentUsers:string) {
  return axios.patch(`${model.baseUrl}${model.controller}/shablon`, { pContagentShablonId, pShablonName, pContragentUsers }).then(extract);
}

async function delShablon(contagentShablonId: number[] | number) {
  return axios.delete(`${model.baseUrl}${model.controller}/shablon`, { data: typeof contagentShablonId === 'number' ? [contagentShablonId] : contagentShablonId }).then(extract);
}

async function readImportFile(file: File) {
  let formData = new FormData();
  formData.append('files', file);
  return axios.post(`${model.baseUrl}${model.controller}/import/read-file`, formData).then(extract);
}

async function importContragents(contragents: any) {
  return axios.post(`${model.baseUrl}${model.controller}/import`, { contragents }).then(extract);
}
